import { Await } from "react-router";
import CustomError from "@components/Error/CustomError";
import {
  SectionSupplementsContext,
  SectionSupplementsPayload,
} from "@pages/Section/layouts/Supplements/utils/types";
import { useRouteContext } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

import PropertySupplementsPageContent from "./PropertySupplementsPageContent";

const PropertySupplementsPage = (): React.ReactElement => {
  const { context } = useRouteContext<SectionSupplementsContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return (
    <Await resolve={context.payload} errorElement={<CustomError />}>
      {({ kind, data }: SectionSupplementsPayload) => {
        if (kind !== "section") {
          // Error or kind is not "newsletter"
          return <CustomError statusCode={context.statusCode} />;
        }

        // StatusCode is 200 and kind is "newsletter"
        return <PropertySupplementsPageContent {...data} />;
      }}
    </Await>
  );
};

export default PropertySupplementsPage;
